import { render, staticRenderFns } from "./insertuser.vue?vue&type=template&id=1568b16b&scoped=true"
import script from "./insertuser.vue?vue&type=script&lang=js"
export * from "./insertuser.vue?vue&type=script&lang=js"
import style0 from "./insertuser.vue?vue&type=style&index=0&id=1568b16b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568b16b",
  null
  
)

export default component.exports